<template>
<div class="spot-blue">
  <div class="tv-animation">
    <img src="~@/assets/img/spot-blue-1.png" alt="Frame 1" />
    <img src="~@/assets/img/spot-blue-2.png" alt="Frame 2"/>
    <img src="~@/assets/img/spot-blue-3.png" alt="Frame 3"/>
    <img src="~@/assets/img/spot-blue-4.png" alt="Frame 4"/>
    <img src="~@/assets/img/spot-blue-5.png" alt="Frame 5"/>
    <img src="~@/assets/img/spot-blue-6.png" alt="Frame 6" />
    <img src="~@/assets/img/spot-blue-7.png" alt="Frame 7"/>
    <img src="~@/assets/img/spot-blue-8.png" alt="Frame 8"/>
    <img src="~@/assets/img/spot-blue-9.png" alt="Frame 9"/>
    <img src="~@/assets/img/spot-blue-10.png" alt="Frame 10"/>
    <img src="~@/assets/img/spot-blue-11.png" alt="Frame 11" />
    <img src="~@/assets/img/spot-blue-12.png" alt="Frame 12"/>
    <img src="~@/assets/img/spot-blue-13.png" alt="Frame 13"/>
    <img src="~@/assets/img/spot-blue-14.png" alt="Frame 14"/>
    <img src="~@/assets/img/spot-blue-15.png" alt="Frame 15"/>
    <img src="~@/assets/img/spot-blue-16.png" alt="Frame 16" />
    <img src="~@/assets/img/spot-blue-17.png" alt="Frame 17"/>
    <img src="~@/assets/img/spot-blue-18.png" alt="Frame 18"/>
    <img src="~@/assets/img/spot-blue-19.png" alt="Frame 19"/>
    <img src="~@/assets/img/spot-blue-20.png" alt="Frame 20"/>
  </div>

</div>
</template>

<script>
export default {
  name: "spot-blue", 
};
</script>

<style lang="scss">
@keyframes play-blue {
  0%,
  5.00% {
    background-image: url("~@/assets/img/spot-blue-1.png");
  }
  5.00%,
  10% {
    background-image: url("~@/assets/img/spot-blue-2.png");
  }
  10%,
  15% {
    background-image: url("~@/assets/img/spot-blue-3.png");
  }
  15%,
  20% {
    background-image: url("~@/assets/img/spot-blue-4.png");
  }
  20%,
  25% {
    background-image: url("~@/assets/img/spot-blue-5.png");
  }
  25%,
  30% {
    background-image: url("~@/assets/img/spot-blue-6.png");
  }
  30%,
  35% {
    background-image: url("~@/assets/img/spot-blue-7.png");
  }
  35%,
  40% {
    background-image: url("~@/assets/img/spot-blue-8.png");
  }
  40%,
  45% {
    background-image: url("~@/assets/img/spot-blue-9.png");
  }
  45%,
  50% {
    background-image: url("~@/assets/img/spot-blue-10.png");
  }
  50%,
  55% {
    background-image: url("~@/assets/img/spot-blue-11.png");
  }
  55%,
  60% {
    background-image: url("~@/assets/img/spot-blue-12.png");
  }
  60%,
  65% {
    background-image: url("~@/assets/img/spot-blue-13.png");
  }
  65%,
  70% {
    background-image: url("~@/assets/img/spot-blue-14.png");
  }
  70%,
  75% {
    background-image: url("~@/assets/img/spot-blue-15.png");
  }
  75%,
  80% {
    background-image: url("~@/assets/img/spot-blue-16.png");
  }
  80%,
  85% {
    background-image: url("~@/assets/img/spot-blue-17.png");
  }
  85%,
  90% {
    background-image: url("~@/assets/img/spot-blue-18.png");
  }
  90%,
  95% {
    background-image: url("~@/assets/img/spot-blue-19.png");
  }
  95%,
  100% {
    background-image: url("~@/assets/img/spot-blue-20.png");
  }
}

.active {
  .tv-blue {
    .tv-animation {
    animation: play-blue 20s step-start;
    background-size: cover;
    background-image: url("~@/assets/img/spot-blue-1.png");
    }
  }
}
 
.tv-blue {
  .tv-animation {
      position: absolute;
      background-repeat: no-repeat;

      img {
        display: none;
      }
  }
}


</style>